import { Btn } from "AbstractElements"
import { exportRanking, getSource } from "Features/Learning/Tryout/Utils/TryoutUtils";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Alert, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { handleWheel } from "Utils/handleWheel";
import AsyncSelectCommon from "Component/Learning/Common/SelectOption/AsyncSelect";
import DatePicker from "react-datepicker";
import Moment from "moment";
import 'moment/locale/id';

const ModalExportRanking = () => {
  const { id } = useParams()
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);
  const [tries, setTries] = useState(1);
  const [selectedValueSource, setSelectedValueSource] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const isExportLoading = useSelector((state) => state.Tryout.isExport);

  const toggle = () => {
    setModalOpen(!modalOpen);
  }

  const handleExport = (e) => {
    e.preventDefault();
    const params = {
      tries: tries,
      source: selectedValueSource?.value,
      date_from: Moment(dateFrom).format('yyyy-MM-DD HH:mm:ss'),
      date_to: Moment(dateTo).format('yyyy-MM-DD HH:mm:ss')
    };
    dispatch(exportRanking({ id, params, handleReset }));
  }

  const handleReset = () => {
    setTries(1);
    setSelectedValueSource(null);
    setDateFrom(null);
    setDateTo(null);
    setModalOpen(false);
  }

  const promiseSourceOptions = async (inputValue, callback) => {
    const fetchDataFromPage = async () => {
      try {
        const response = await dispatch(
          getSource({
            "source": inputValue
          })
        );
        return response.payload.data;
      } catch (error) {
        console.error("Error fetching options:", error);
        return [];
      }
    };

    const fetchDataRecursively = async () => {
      const responsePayload = await fetchDataFromPage();

      if (responsePayload.length > 0) {
        responsePayload.map(item => {
          console.log('responsePayload', item);
        })
        const options = responsePayload.map((item) => ({
          value: item,
          label: item
        }));
        console.log('options', options);
        callback(options);
      } else {
        callback({});
      }
    };

    await fetchDataRecursively();
  };

  const handleSelectChangeSource = (selectedOption) => {
    setSelectedValueSource(selectedOption);
  };

  return (
    <>
      <Btn attrBtn={{ color: "info", onClick: toggle }}>
        <i className="fa fa-upload fa-lg me-2"></i>Export Ranking
      </Btn>

      <Modal isOpen={modalOpen} toggle={toggle} backdrop="static" size="lg" centered>
        <ModalHeader toggle={toggle}>Export Ranking</ModalHeader>
        <ModalBody>
          <Alert color="info" className="mb-3">
            <strong>ℹ️ Catatan:</strong> Ranking dihitung berdasarkan waktu selesai tryout yang ditentukan (must end), bukan waktu submit jawaban.
          </Alert>
          <Form className="row need-validation">
            <FormGroup className="mb-3">
              <Label for="tries" className="form-label">Tries</Label>
              <Input type="number" id="tries" name="tries" min="1" placeholder="Masukkan jumlah percobaan" required onWheel={handleWheel} value={tries} onChange={(e) => setTries(e.target.value)} />
            </FormGroup>
            <AsyncSelectCommon
              label={"Pilih Source"}
              placeholder={"Silahkan pilih Source..."}
              promiseOptions={promiseSourceOptions}
              handleSelectChange={handleSelectChangeSource}
              selectedValue={selectedValueSource}
            />
            <Row>
              <Col sm="6">
                <FormGroup>
                  <Row>
                    <Col sm="12">
                      <Label for="dateFrom" className="form-label" style={{ fontWeight: 'bold' }}>Mulai dari:</Label>
                    </Col>
                    <Col sm="12">
                      <DatePicker
                        id="dateFrom"
                        className="form-control digits"
                        showPopperArrow={false}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        timeFormat="HH:mm:ss"
                        showTimeSelect
                        closeOnScroll={true}
                        selected={dateFrom}
                        onChange={setDateFrom}
                        isClearable
                        placeholderText="Pilih tanggal mulai!"
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col sm="6">
                <FormGroup>
                  <Row>
                    <Col sm="12">
                      <Label for="dateTo" className="form-label" style={{ fontWeight: 'bold' }}>Sampai dengan:</Label>
                    </Col>
                    <Col sm="12">
                      <DatePicker
                        id="dateTo"
                        className="form-control digits"
                        showPopperArrow={false}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        timeFormat="HH:mm:ss"
                        showTimeSelect
                        closeOnScroll={true}
                        selected={dateTo}
                        onChange={setDateTo}
                        isClearable
                        placeholderText="Pilih tanggal akhir!"
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle }}>Cancel</Btn>
          <Btn attrBtn={{ color: "primary", onClick: handleExport, disabled: isExportLoading }}>Export</Btn>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ModalExportRanking